import React from 'react'

const AuditLog = () => {
  return (
    <div>
      
    </div>
  )
}

export default AuditLog
